export default __webpack_public_path__ + "static/media/870.4dda481e.jpg";